import { Box, Typography } from '@material-ui/core';
import { FiChevronLeft } from 'react-icons/fi';
import { FiChevronRight } from 'react-icons/fi';

import { monochrome } from '@vyce/core/src/theme/styles';

export const TimeLogSwitcher = ({
  onPrevious,
  onNext,
  text,
  minWidth,
}: {
  onPrevious: () => void;
  onNext: () => void;
  text: string;
  minWidth?: string;
}) => {
  return (
    <Box
      style={{ padding: '4px 16px', cursor: 'pointer' }}
      display="flex"
      width="fit-content"
      alignItems="center"
      gridGap={8}
      borderRadius={16}
      border={`1px solid ${monochrome.mediumlight}`}
    >
      <FiChevronLeft size={24} color={monochrome.mediumdark} onClick={onPrevious} />

      <Box minWidth={minWidth || '150px'} textAlign="center">
        <Typography style={{ fontSize: 15 }}>{` ${text}`}</Typography>
      </Box>

      <FiChevronRight size={24} color={monochrome.mediumdark} onClick={onNext} />
    </Box>
  );
};
